import { render, staticRenderFns } from "./purchases.vue?vue&type=template&id=2544706d&scoped=true&"
import script from "./purchases.vue?vue&type=script&lang=js&"
export * from "./purchases.vue?vue&type=script&lang=js&"
import style0 from "./purchases.vue?vue&type=style&index=0&id=2544706d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2544706d",
  null
  
)

export default component.exports